<template>
    <section class="global-checkout" :class="dark ? 'dark' : 'light'">
        <!-- O Loader já está aqui e controlado por isProcessingPayment -->
        <Loader :isActive="isProcessingPayment" />
        <section class="checkout">
            <section class="breadcrumbs">
                <a href="javascript:void(0);" @click="redirect"><span><i class="pi pi-arrow-left"></i>Voltar</span></a>
            </section>
            <section class="primary-content-checkout">
                <div class="data-checkout">
                    <div class="personal-data-checkout">
                        <!-- Exibição de erros -->
                        <div class="error-messages" v-if="errorPayment">
                            <div class="error-message">
                                <p><i class="pi pi-exclamation-circle"></i> {{errorPaymentMessage}}</p>
                            </div>
                        </div>

                        <div class="step">
                            <h3 class="title-personal-data-checkout"><span class="step">1</span> Dados Pessoais</h3>
                        </div>
                        <div class="inputs-personal-data-checkout">
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>Nome completo</span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="text" class="form-control" v-model="customerName" placeholder="Digite seu nome completo" required>
                                </div>
                            </div>
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>Email</span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="email" class="form-control" v-model="customerEmail" placeholder="seu@email.com" required>
                                </div>
                            </div>
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>CPF</span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="text" class="form-control" v-model="cpf" placeholder="123.456.789-00" v-mask="'###.###.###-##'" required>
                                </div>
                            </div>
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>Telefone</span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="text" class="form-control" v-model="customerPhone" placeholder="(00) 00000-0000" v-mask="'(##) #####-####'" required>
                                </div>
                            </div>
                        </div>
                        <div class="step" v-if="price > 0 || itemCheckoutWeflix?.comercialName!=null">
                            <h3 class="title-personal-data-checkout"><span class="step">2</span> Dados de Pagamento</h3>
                        </div>
                        <!-- <div class="options_payment-checkout">
                            <div class="option-payment" :class="paymentMethod == 1 ? 'active' : ''" @click="setPaymentMethod(1)">
                                <div class="option-payment-title">
                                    <fa icon="fa-credit-card" />
                                    <h4>Cartão de Crédito</h4>
                                </div>
                            </div>
                        </div> -->
                        <div class="billing" v-show="paymentMethod == 1 && (price > 0 || itemCheckoutWeflix?.comercialName!=null)">
                            <div class="credit-card-option">
                                <div class="info-credit-card">
                                    <div class="form-group">
                                        <div class="form-label">
                                            <label>
                                                <span>Nome completo do titular</span>
                                            </label>
                                        </div>
                                        <div class="form-input">
                                            <input type="text" class="form-control" v-model="cardName" placeholder="Nome completo" required>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-label">
                                            <label>
                                                <span>Número do cartão</span>
                                            </label>
                                        </div>
                                        <div class="form-input">
                                            <input type="text" class="form-control" v-model="cardNumber" placeholder="1234 5678 9012 3456" v-mask="'#### #### #### ####'" required>
                                        </div>
                                    </div>
                                    <div class="info-flex">
                                        <div class="form-group">
                                            <div class="form-label">
                                                <label>
                                                    <span>Data de vencimento</span>
                                                </label>
                                            </div>
                                            <div class="form-input">
                                                <input type="text" class="form-control" v-model="cardExpiry" v-mask="'##/##'" placeholder="MM/AA" required>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="form-label">
                                                <label>
                                                    <span>Código de segurança</span>
                                                </label>
                                            </div>
                                            <div class="form-input">
                                                <input type="text" class="form-control" v-model="cardCVV" placeholder="CVC" v-mask="'###'" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="price > 0 || itemCheckoutWeflix?.comercialName!=null">
                                        <div class="form-label">
                                            <label>
                                                <span>Parcelamento</span>
                                            </label>
                                        </div>
                                        <div class="form-select2">
                                            <select class="select2-option" v-model="selectedPlan" required>
                                                <option :value="i" v-for="i in getInstallmentOptions()" :key="i">{{i}}x R$ {{formatPrice(price / i)}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-credit-card">
                                    <div class="card-box">
                                        <div class="chip">
                                            <svg class="Chip" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 387.8 380.3" style="enable-background:new 0 0 387.8 380.3;" xml:space="preserve">
                                                <defs>
                                                    <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                        <stop offset="0%" stop-color="#c79750"></stop>
                                                        <stop offset="20%" stop-color="#e6b964"></stop>
                                                        <stop offset="50%" stop-color=" #f8e889"></stop>
                                                        <stop offset="80%" stop-color=" #deb15f"></stop>
                                                        <stop offset="100%" stop-color=" #dfb461"></stop>
                                                    </linearGradient>
                                                </defs>
                                                <g id="XMLID_4_">
                                                    <path id="XMLID_1_" class="st0" d="M308.8,375.3H79.1C38.2,375.3,5,342.1,5,301.2V79.1C5,38.2,38.2,5,79.1,5h229.7
                                                        c40.9,0,74.1,33.2,74.1,74.1v222.2C382.8,342.1,349.7,375.3,308.8,375.3z"></path>
                                                    <line id="XMLID_2_" class="st0" x1="109.9" y1="5.1" x2="109.9" y2="375.1"></line>
                                                    <line id="XMLID_3_" class="st0" x1="4.9" y1="95.1" x2="109.9" y2="95.1"></line>
                                                    <line id="XMLID_7_" class="st0" x1="4.9" y1="185.1" x2="109.9" y2="185.1"></line>
                                                    <line id="XMLID_8_" class="st0" x1="1.9" y1="275.1" x2="106.9" y2="275.1"></line>
                                                    <line id="XMLID_9_" class="st0" x1="276.9" y1="275.1" x2="381.9" y2="275.1"></line>
                                                    <line id="XMLID_10_" class="st0" x1="274.9" y1="185.1" x2="379.9" y2="185.1"></line>
                                                    <line id="XMLID_11_" class="st0" x1="277.9" y1="95.1" x2="382.9" y2="95.1"></line>
                                                    <g id="XMLID_6_">
                                                        <g id="XMLID_14_">
                                                            <g id="XMLID_32_">
                                                                <path id="XMLID_33_" d="M277.4,90.1h-1c-2.5,0-4.5,2-4.5,4.5v272c0,2.5,2,4.5,4.5,4.5h1c2.5,0,4.5-2,4.5-4.5v-272
                                                                    C281.9,92.1,279.9,90.1,277.4,90.1z"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="name">
                                            {{ cardName || 'Seu nome' }}
                                        </div>

                                        <div class="number">
                                            {{ cardNumber ? formatCardNumber(cardNumber) : 'XXXX XXXX XXXX XXXX' }}
                                        </div>
                                        <div class="otherInfo" style="display:flex;">
                                            <div class="date">
                                                {{ cardExpiry || 'MM/AA' }}
                                            </div>
                                            <div class="cvc">
                                                {{ cardCVV || 'XXX' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- typePayment: 1=cartão, 2=PIX, 3=boleto -->
                        <div class="payment-method-pix" v-show="paymentMethod == 2">
                            <img src="@/assets/Weflix/pix.png" class="imagePix" alt="payment">
                            <div class="pix-info">
                                <p>O QR Code Pix será gerado após a confirmação da compra.</p>
                                <p>O pagamento é processado instantaneamente.</p>
                            </div>
                        </div>
                        <div class="payment-method-boleto" v-show="paymentMethod == 3">
                            <img src="@/assets/Weflix/boleto2.png" class="imageBoleto" alt="payment">
                            <div class="boleto-info">
                                <p>O boleto será gerado após a confirmação da compra.</p>
                                <p>O prazo de compensação é de até 3 dias úteis.</p>
                            </div>
                        </div>
                        <div class="trial-activation" v-if="price == 0 && itemCheckoutWeflix?.comercialName==null">
                            <div class="trial-message">
                                <h3>Ative seu período de teste gratuito!</h3>
                                <p>Aproveite todos os recursos da plataforma sem compromisso durante o período experimental.</p>
                                <div class="trial-steps">
                                    <p><fa icon="fa-envelope" /> Você receberá um e-mail com instruções para ativação</p>
                                    <p><fa icon="fa-link" /> Clique no link de ativação enviado para seu e-mail</p>
                                    <p><fa icon="fa-lock" /> Defina sua senha de acesso</p>
                                    <p><fa icon="fa-check-circle" /> Comece a usar a plataforma imediatamente</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="product-checkout">
                        <h3 class="title-personal-data-checkout" style="text-align: left;"><span class="step">3</span> Finalização</h3>
                        <div class="box-product-checkout">
                            <div class="planSubscription" v-if="itemCheckoutWeflix?.type !== 0">
                                <div class="plan-details">
                                    <div class="plan-info">
                                        <div class="plan-name">
                                            <h4>
                                                <p v-if="price>0" style="margin-bottom: 10px;">Assinatura: </p>
                                                {{itemCheckoutWeflix?.name?.length > 15 ? itemCheckoutWeflix?.name?.slice(0, 15) + '...' : itemCheckoutWeflix?.name}}
                                            </h4>
                                        </div>
                                        <div class="plan-price">
                                            <p>
                                                <span class="price"><span class="priceSubscription">R${{ formatPrice(price).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') }}</span></span></p>
                                            <p v-if="installments>1 && finalWebsite.intallmentCheckout === 1 && price > 0"><span class="installment">EM ATÉ {{ installments }}x DE</span> <span class="priceSubscription">R$ {{ formatPrice(price / installments) }}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="couponSection" v-if="price > 0 && itemCheckoutWeflix?.comercialName==null">
                                <button class="toggleCoupon" @click="showCouponInput = !showCouponInput">
                                    <fa icon="fa-tag" /> {{ showCouponInput ? 'Ocultar cupom' : 'Adicionar cupom' }}
                                </button>
                            </div>
                            <div v-if="showCouponInput" class="couponInput">
                                <input type="text" v-model="couponCode" placeholder="Digite seu cupom" class="form-control">
                                <button @click="validateCoupon" class="validateCoupon" :disabled="!couponCode">
                                    Aplicar
                                </button>
                            </div>
                            <p v-if="couponMessage" :class="{'success-message': couponValid, 'error-message': !couponValid}">
                                {{ couponMessage }}
                            </p>
                            <div class="payment-action">
                                <button class="buttonCheckout payment active" @click="checkoutPayment" :disabled="isButtonDisabled" v-if="price > 0">
                                    Finalizar Compra
                                </button>
                                <button class="buttonCheckout payment active" @click="activeTrial" :disabled="isButtonDisabled" v-if="price == 0">
                                   Ativar Trial
                                </button>
                                <div class="secure-payment">
                                    <fa icon="fa-lock" /> Pagamento 100% seguro
                                </div>
                                <div ref="recaptcha" class="g-recaptcha"></div>
                            </div>
                            <!-- <div class="trial-activation" v-if="price === 0">
                                <div class="trial-message">
                                    <h3>Ative seu período de teste gratuito!</h3>
                                    <p>Aproveite todos os recursos da plataforma sem compromisso durante o período experimental.</p>
                                </div>
                               
                            </div> -->
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <section class="footer checkout_subscription">
            <div class="footer-content">
                <div class="footer-section">
                    <h4>Atendimento</h4>
                    <p>Seg a Sex - 9h às 18h</p>
                    <p>suporte@weflix.com</p>
                </div>
                <div class="footer-section">
                    <h4>Pagamento Seguro</h4>
                    <p class="payment-methods">
                        <fa icon="fa-lock" /> SSL Secure Payment
                    </p>
                </div>
                <div class="footer-section">
                    <h4>Políticas</h4>
                   <p> <a href="#">Termos de Uso</a></p>
                   <p> <a href="#">Política de Privacidade</a></p>
                </div>
            </div>
            <div class="footer-bottom">
                <p>&copy; 2024 Weflix. Todos os direitos reservados.</p>
            </div>
        </section>
    </section>
    <div class="backgroundLoginRegister"></div>
    <div class="trial-success-overlay" v-if="showTrialSuccess">
        <div class="trial-success-popup">
            <h3>Trial Ativado com Sucesso!</h3>
            <button class="buttonCheckout active" @click="goToSite">
                Ir para o site
            </button>
        </div>
    </div>
    <div class="payment-loader-overlay" v-if="isProcessingPayment">
        <div class="payment-loader">
            <fa icon="fa-spinner" class="fa-spin" />
            <p style="color: #fff; margin-top: 15px; font-size: 1.2rem;">Processando seu pedido<span class="loading-dots"></span></p>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ApiPayment from '@/utils/Weflix/Website/payment';

export default {
    data() {
        return {
            openModalLogin: false,
            typeLogin: 1,
            hasReadyToLogin: false,
            typeInput: 'password',
            remainingTime: 15 * 60,
            timerInterval: null,
            paymentMethod: 1,
            cardNumber: '',
            cardName: '',
            cardExpiry: '',
            cardCVV: '',
            cpf: '',
            selectedPlan: 1,
            installments: 0,
            errorPayment: false,
            errorType: '', // novo campo para controlar tipo de erro
            showCouponInput: false,
            couponCode: '',
            couponValid: false,
            couponMessage: '',
            price: 0,
            errorPaymentMessage: '',
            trial: {
                days: 30
            },
            showTrialSuccess: false,
            isProcessingPayment: false,
            isButtonDisabled: false,

            customerName: '',
            customerEmail: '',
            customerPhone: '',
            customerBirthdate: '',

            //Token
            siteKey: '6LcWfigrAAAAAKY18LmZ7RsEcMoJIy2URspCgQy3',
            recaptchaToken: '',
            showRecaptcha: false,
        }
    },
    mounted() {
        if(this.collectionCheckout){
            this.price = this.itemCheckoutWeflix.price;
        }
    },
    computed: {
        ...mapState(['collectionCheckout', 'userPortalWeflix', 'finalWebsite', 'dataPaymentWeflix',]),
        isFormValid() {
            if (this.price === 0) return true;

            // Validação básica dos dados do cliente
            const isCustomerDataValid =
                this.customerName.length > 3 &&
                this.customerEmail.includes('@') &&
                this.customerPhone.length >= 14 &&
                this.customerBirthdate.length === 10 &&
                this.cpf.length === 14;

            if (this.paymentMethod === 1) {
                return isCustomerDataValid &&
                    this.cardNumber.length === 19 &&
                    this.cardName.length > 3 &&
                    this.cardExpiry.length === 5 &&
                    this.cardCVV.length === 3;
            }

            return isCustomerDataValid;
        },

    },
    methods: {
        ...mapActions(['storeUserPortalWeflix', 'storeDataPaymentWeflix']),

        async loadRecaptcha() {
            try {
                await this.$recaptchaLoaded()
                const token = await this.$recaptcha('checkout');
                console.log(token);
                this.recaptchaToken = token;
                return token;
            } catch (error) {
                console.error('Erro ao executar reCAPTCHA:', error);
                throw error;
            }
        },

        onRecaptchaComplete(token) {
            this.recaptchaToken = token
        },

        async checkoutPayment() {
            // Verifica se todos os campos obrigatórios existem
            if (!this.customerName || !this.customerEmail || !this.customerPhone || !this.cpf) {
                this.errorPayment = true
                this.errorPaymentMessage = 'Por favor, preencha todos os dados pessoais'
                return
            }

            if (this.paymentMethod === 1 && (!this.cardNumber || !this.cardExpiry || !this.cardCVV)) {
                this.errorPayment = true 
                this.errorPaymentMessage = 'Por favor, preencha todos os dados do cartão'
                return
            }

            this.isButtonDisabled = true
            this.isProcessingPayment = true
            this.errorPayment = false
            this.errorType = ''

            try {
                const baseUrl = window.location.href.includes('localhost:8080')
                    ? process.env.VUE_APP_BASE_URL_HOMOLOGATION
                    : window.location.href.split('/checkoutweflix')[0]

                const payload = {
                    url: baseUrl,
                    user: {
                        name: this.customerName,
                        email: this.customerEmail,
                        phone: this.customerPhone,
                        socialNumber: this.cpf.replace(/[^\d]/g,'')
                    },
                    simpleRequest: {
                        idPlan: this.itemCheckoutWeflix.id,
                        typePayment: this.paymentMethod,
                        installments: this.installments,
                        card: {
                            number: this.cardNumber.replace(/\s/g, ''),
                            exp_month: parseInt(this.cardExpiry.split('/')[0]),
                            exp_year: parseInt(this.cardExpiry.split('/')[1]),
                            cvv: this.cardCVV
                        }
                    }
                }

                const response = await ApiPayment.checkout(payload)
                this.storeDataPaymentWeflix({ dataPaymentWeflix: response })
                this.$router.push('/sucessoWeflix')
            } catch (error) {
                this.errorPayment = true
                
                // Tratamento específico dos erros
                if (error.response) {
                    console.log(error.response.data.message)
                    this.errorPaymentMessage = error.response.data.message
                } else {
                    this.errorType = 'payment'
                    this.errorPaymentMessage = 'Erro ao processar pagamento. Por favor, tente novamente.'
                }
                
                console.error('Erro ao realizar checkout:', error)
            } finally {
                this.isProcessingPayment = false
                this.isButtonDisabled = false
            }
        },

        startTimer() {
            this.timerInterval = setInterval(() => {
                if (this.remainingTime > 0) {
                    this.remainingTime--;
                } else {
                    this.stopTimer();
                }
            }, 1000);
        },
    },
    computed: {
        ...mapState(['itemCheckoutWeflix', 'userPortalWeflix', 'finalWebsite', 'dataPaymentWeflix']),
        isFormValid() {
            if (this.price === 0) return true;

            // Validação básica dos dados do cliente
            const isCustomerDataValid =
                this.customerName.length > 3 &&
                this.customerEmail.includes('@') &&
                this.customerPhone.length >= 14 &&
                this.customerBirthdate.length === 10 &&
                this.cpf.length === 14;

            if (this.paymentMethod === 1) {
                return isCustomerDataValid &&
                    this.cardNumber.length === 19 &&
                    this.cardName.length > 3 &&
                    this.cardExpiry.length === 5 &&
                    this.cardCVV.length === 3;
            }

            return isCustomerDataValid;
        },

    },
    methods: {
        ...mapActions(['storeUserPortalWeflix', 'storeDataPaymentWeflix']),

        async loadRecaptcha() {
            try {
                await this.$recaptchaLoaded()
                const token = await this.$recaptcha('checkout');
                console.log(token);
                this.recaptchaToken = token;
                return token;
            } catch (error) {
                console.error('Erro ao executar reCAPTCHA:', error);
                throw error;
            }
        },

        onRecaptchaComplete(token) {
            this.recaptchaToken = token
        },

        async checkoutPayment() {
            // Verifica se todos os campos obrigatórios existem
            if (!this.customerName || !this.customerEmail || !this.customerPhone || !this.cpf) {
                this.errorPayment = true
                this.errorPaymentMessage = 'Por favor, preencha todos os dados pessoais'
                return
            }

            if (this.paymentMethod === 1 && (!this.cardNumber || !this.cardExpiry || !this.cardCVV)) {
                this.errorPayment = true 
                this.errorPaymentMessage = 'Por favor, preencha todos os dados do cartão'
                return
            }

            this.isButtonDisabled = true
            this.isProcessingPayment = true
            this.errorPayment = false
            this.errorType = ''

            try {
                const baseUrl = window.location.href.includes('localhost:8080')
                    ? process.env.VUE_APP_BASE_URL_HOMOLOGATION
                    : window.location.href.split('/checkoutweflix')[0]

                const payload = {
                    url: baseUrl,
                    user: {
                        name: this.customerName,
                        email: this.customerEmail,
                        phone: this.customerPhone,
                        socialNumber: this.cpf.replace(/[^\d]/g,'')
                    },
                    simpleRequest: {
                        idPlan: this.itemCheckoutWeflix.id,
                        typePayment: this.paymentMethod,
                        installments: this.installments,
                        card: {
                            number: this.cardNumber.replace(/\s/g, ''),
                            exp_month: parseInt(this.cardExpiry.split('/')[0]),
                            exp_year: parseInt(this.cardExpiry.split('/')[1]),
                            cvv: this.cardCVV
                        }
                    }
                }

                const response = await ApiPayment.checkout(payload)
                this.storeDataPaymentWeflix({ dataPaymentWeflix: response })
                this.$router.push('/sucessoWeflix')
            } catch (error) {
                this.errorPayment = true
                
                // Tratamento específico dos erros
                if (error.response) {
                    console.log(error.response.data.message)
                    this.errorPaymentMessage = error.response.data.message
                } else {
                    this.errorType = 'payment'
                    this.errorPaymentMessage = 'Erro ao processar pagamento. Por favor, tente novamente.'
                }
                
                console.error('Erro ao realizar checkout:', error)
            } finally {
                this.isProcessingPayment = false
                this.isButtonDisabled = false
            }
        },

        startTimer() {
            this.timerInterval = setInterval(() => {
                if (this.remainingTime > 0) {
                    this.remainingTime--;
                } else {
                    this.stopTimer();
                }
            }, 1000);
        },
        async getCollectionBySlug() {
            const slug = this.$route.params.slug;
            try {
                const response = await ApiPayment.getCollectionBySlug(slug);
                console.log(response);
            } catch (error) {
                console.error('Erro ao obter dados da collection:', error);
            }
        },
        stopTimer() {
            clearInterval(this.timerInterval);
        },
        formatTime(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
        },
        setPaymentMethod(method) {
            this.paymentMethod = method;
        },
        formatPrice(price) {
            return price.toFixed(2).replace('.', ',');
        },
        redirect() {
            window.location = '/';
        },
        getInstallmentOptions() {
            if (!this.itemCheckoutWeflix) return [1];

            switch (this.itemCheckoutWeflix.type) {
                case 1: return [1];
                case 2: return Array.from({ length: 6 }, (_, i) => i + 1);
                case 3: return Array.from({ length: 3 }, (_, i) => i + 1);
                case 4: return Array.from({ length: 12 }, (_, i) => i + 1);
                default: return [1];
            }
        },
        calcularNumeroParcelas(price) {
            if (!this.itemCheckoutWeflix) {
                this.installments = 1;
                return;
            }

            switch (this.itemCheckoutWeflix.type) {
                case 1:
                    this.installments = 1;
                    break;
                case 2:
                    this.installments = Math.min(6, Math.floor(price / 5));
                    break;
                case 3:
                    this.installments = Math.min(3, Math.floor(price / 5));
                    break;
                case 4:
                    this.installments = Math.min(12, Math.floor(price / 5));
                    break;
                default:
                    this.installments = 1;
            }
        },
        formatCardNumber(number) {
            return number.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
        },
        async validateCoupon() {
            try {
                const response = await ApiPayment.validateCoupon(this.couponCode, this.finalWebsite.company.id);

                if (response && response.discount) {
                    this.couponValid = true;
                    this.couponMessage = 'Cupom aplicado com sucesso!';
                    this.price = this.price - (this.price * response.discount / 100);
                    this.calcularNumeroParcelas(this.price);
                } else {
                    this.couponValid = false;
                    this.couponMessage = 'Cupom inválido';
                }
            } catch (error) {
                this.couponValid = false;
                this.couponMessage = 'Erro ao validar cupom';
                console.error('Erro ao validar cupom:', error);
            }
        },
        async activeTrial() {
            this.showTrialSuccess = true;
            try {
                const response = await ApiPayment.activeTrial(this.userPortalWeflix.acessToken);
                this.$router.push('/sucesso-trial')
            } catch (error) {
                console.error('Erro ao ativar trial:', error);
            } finally {
              
            }
        },
        goToSite() {
            window.location.href = "/";
        }
    },
    mounted() {
        this.startTimer();
        if (this.itemCheckoutWeflix) {
            console.log(this.itemCheckoutWeflix);
            this.price = this.itemCheckoutWeflix.price;
        }

        // Preencher dados do cliente se disponíveis no userPortalWeflix
        if (this.userPortalWeflix && this.userPortalWeflix.user) {
            this.customerName = this.userPortalWeflix.user.name || '';
            this.customerEmail = this.userPortalWeflix.user.email || '';
            this.customerPhone = this.userPortalWeflix.user.phone || '';
            this.cpf = this.userPortalWeflix.user.document || '';
        }
    },
    beforeUnmount() {
        this.stopTimer();
    },
    watch: {
        itemCheckoutWeflix(newValue) {
            this.calcularNumeroParcelas(this.price);
        }
    },
    created() {
        this.calcularNumeroParcelas(this.price);
        const slug = this.$route.params.slug;
        if (slug) {
            this.getCollectionBySlug(slug);
        }
    }
}
</script>

<style scoped>
@import url('./checkout.css');

.footer {
    background-color: #f8f8f8;
    padding: 20px 0;
    text-align: center;
    color: #333;
}

.footer-content {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 20px;
}

.footer-section {
    flex: 1;
    min-width: 200px;
    margin: 10px;
}

.footer-section h4 {
    font-size: 18px;
    margin-bottom: 10px;
    color: #555;
}

.footer-section p,
.footer-section a {
    font-size: 14px;
    color: #777;
    text-decoration: none;
    display: block;
}

.footer-section a:hover {
    text-decoration: underline;
}

.footer-bottom {
    border-top: 1px solid #ddd;
    padding-top: 10px;
    font-size: 12px;
    color: #999;
}
.button-checkout:hover {
    background-color: #e59417;
}
.card-box{
    position: relative;
}
.card-box .chip {
    position: absolute;
    top: 20px;
    left: 20px;
    position: relative;
}

.card-box .number {
    position: absolute;
    bottom: 80px;
    left: 20px;
    font-family: "Poppins";
    font-weight: 500;
    color: #fff;
}

.card-box .name {
    position: absolute;
    bottom: 51px;
    left: 20px;
    font-family: "Poppins";
    font-weight: 500;
    color: #fff;
    font-size: 16px;
}

.card-box .otherInfo {
    font-size: 16px;
    position: absolute;
    bottom: 20px;
    left: 20px;
    font-family: "Poppins";
    font-weight: 500;
    color: #fff;
}

.cupon-discount input {
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #dbdcde;
    border-radius: 0.35em;
}

.cupon-discount button {
    padding: 0.5rem 1rem;
    background-color: #ffa519;
    color: #fff;
    border: none;
    border-radius: 0.35em;
    cursor: pointer;
}

.cupon-discount button:hover {
    background-color: #e59417;
}

.box-product-checkout {
    background-color: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
}

.plan-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.plan-name h4 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.plan-price {
    text-align: right;
}

.plan-price .priceSubscription {
    font-size: 18px;
    font-weight: 700;
    color: #000000;
}

.couponSection {
    margin-top: 10px;
}

.toggleCoupon {
    background-color: #e6e6e68a;
    color: #575757;
    border: none;
    padding: 4px 15px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
}

.couponInput {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.couponInput .form-control {
    flex: 1;
    margin-right: 10px;
}

.validateCoupon {
    background-color: #4caf50;
    color: #fff;
    border: none;
    padding: 5px 5px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.validateCoupon:hover {
    background-color: #388e3c;
}

.payment-action {
    margin-top: 20px;
    text-align: center;
}

.buttonCheckout.payment {
    background-color: #4CAF50;
    color: #fff;
    border: none;
    padding: 10px 30px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
}

.secure-payment {
    margin-top: 10px;
    font-size: 12px;
    color: #777;
}
.secure-payment svg{
    font-size: 12px;
}

.trial-activation {
    margin-top: 20px;
    text-align: center;
}

.trial-message h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.trial-action .buttonCheckout.trial {
    background-color: #4caf50;
    color: #fff;
    border: none;
    padding: 15px 30px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.trial-action .buttonCheckout.trial:hover {
    background-color: #388e3c;
}
.plan-info {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: end;
}
.plan-info p{
    margin-bottom: 0;
}
select.select2-option {
    width: 100%;
    padding: 7px;
    border: 1px solid #dbdcde;
    border-radius: 5px;
    background-color: white;
}
svg.svg-inline--fa.fa-credit-card {
    color: #c8c8c8;
}
.billing {
    background-color: #f9f9f9;
}

@media (max-width: 768px) {
    .credit-card-option {
        display: flex;
        flex-wrap: wrap;
        gap: 0px!important;
        flex-direction: column;
    }
    section.primary-content-checkout {
        padding: 10px;
    }
    section.breadcrumbs {
        padding: 10px;
    }
    .footer-content {
        flex-direction: column;
        padding: 0 20px;
    }

    .footer-section {
        margin: 20px 0;
        text-align: center;
    }

    .plan-details {
        flex-direction: column;
        text-align: center;
    }

    .plan-price {
        margin-top: 10px;
        text-align: center;
    }

    .couponInput {
        flex-direction: column;
    }

    .couponInput .form-control {
        margin-right: 0;
        margin-bottom: 10px;
        width: 100%;
    }

    .validateCoupon {
        width: 100%;
    }



    .plan-name {
        text-align: left;
    }

    .plan-info p {
        margin: 5px 0;
    }

    .box-product-checkout {
        margin: 10px;
        padding: 15px;
    }

    .billing {
        padding: 15px;
    }
    .product-checkout {
        width: 100%;
        position: relative;
        right: 0;
        margin: 40px 0px;
        top: 0;
    }
    .card-credit-card {
        transform: translateY(5px);
        padding: 10px;
    }
}
.product-checkout {
    top: 0;
}
.payment-loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7); /* Fundo semi-transparente */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050; /* Garante que fique acima de outros elementos */
}

.payment-loader {
    text-align: center;
}

.payment-loader .fa-spinner {
    font-size: 4rem; /* Tamanho do ícone */
    color: #fff; /* Cor do ícone */
}

/* Estilo para os pontos de carregamento */
.loading-dots::after {
    content: '.';
    animation: dots 1.4s steps(5, end) infinite;
    display: inline-block; /* Garante que a animação funcione */
    width: 1em; /* Ajuste conforme necessário */
    text-align: left;
}

@keyframes dots {
    0%, 20% {
        content: '.';
    }
    40% {
        content: '..';
    }
    60% {
        content: '...';
    }
    80%, 100% {
        content: '...'; /* Mantém três pontos no final */
    }
}
.trial-activation {
    margin-top: 20px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.trial-message {
    text-align: center;
}

.trial-message h3 {
    color: #2c3e50;
    font-size: 1.5rem;
    margin-bottom: 15px;
}

.trial-message p {
    color: #6c757d;
    margin-bottom: 20px;
}

.trial-steps {
    text-align: left;
    padding: 10px;
}

.trial-steps p {
    margin: 10px 0;
    padding: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #495057;
}

.trial-steps .fa {
    color: #28a745;
    font-size: 1.2em;
}
.data-checkout input.form-control::placeholder {
    color: black !important;
}
.error-message p {
    color: #9d0303;
}
section.footer.checkout_subscription {
    display: block;
}
</style>
